<template>
	<li class="uk-open">
		<a v-if="colorOnly" href="#" class="uk-accordion-title">1. Bed Color</a>
		<a v-else href="#" class="uk-accordion-title">1. Size and color</a>
		<div class="uk-accordion-content">
			<div v-if="!colorOnly" class="input-select">
				<label for="bedsize">Bed Size</label>
				<button v-for="bedSize in bed_sizes" :key="'bsize_option_'+bedSize.id" class="pill-size-option"
						:class="{selected:sizeIsSelected(bedSize.id)}" @click.prevent="setSize(bedSize.id)">
					{{ bedSize.mattress_size.name }}
				</button>
			</div>
			<!-- Size and color -->
			<div class="wood-type-container section-overflow">
				<div class="uk-child-width-1-3@s uk-grid-small uk-child-width-1-2" uk-grid>
					<div v-for="finish in popular_finishes" :key="'finish_option_'+finish.id">
						<div v-if="finish.finish" class="wood-type" :class="{'selected' : isActive(finish)}" @click.prevent="onClick(finish)">
							<img :src="imgStyle(finish.finish)" alt="Wood Type Placeholder">
							<p class="name">{{ finish.finish.name }} / {{ finish.wood.name }}</p>
							<p class="extra-price">{{ calculateUpcharge(finish) | diffcurrency }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "",

	props: {
		dataFailure: {
			type: Boolean,
			default: false
		},
		colorOnly: {
			type: Boolean,
			default: false
		}
	},
	components: {},
	data() {
		return {
			selectedSizeId: 0
		}
	},
	mounted() {

	},
	methods: {
		imgStyle(finish) {
			if(finish && finish.image){
				return `${finish.image.webPath}/160`;
			}
			return '';
		},
		setSize(sizeId) {
			this.selectedSizeId = sizeId;
		},
		/**
		 * user clicked on one of the popular finishes
		 * @param  {[type]} finish [description]
		 * @return {[type]}        [description]
		 */
		onClick(selected_finish) {
			this.$store.commit('setSelectedPopularFinish', selected_finish);
			// loop through and find matching wood
			let wood = null;
			for (let w in this.woods) {
				wood = this.woods[w];
				if (wood.id == selected_finish.wood_id) {
					break;
				}
			}
			// save to store.
			this.$store.commit('setSelectedWood', wood);
			setTimeout(() => {
				let finish = null;
				for (let f in this.wood_finishes) {
					finish = this.wood_finishes[f];
					if (finish.id == selected_finish.finish_id) {
						break;
					}
				}
				this.$store.commit('setSelectedFinish', finish);
			}, 0);
		},
		/**
		 * see if this is the selected finish.
		 * @param  {[type]}  finish [description]
		 * @return {Boolean}        [description]
		 */
		isActive(finish) {
			if (this.selected_popular_finish == null) return false;
			return this.selected_popular_finish.id == finish.id;
		},
		sizeIsSelected(sizeId) {
			return this.selectedSizeId == sizeId;
		},
		calculateUpcharge(finish) {
			let wallbedUpcharge = finish.finish.grade.wallbed_upcharge;
			wallbedUpcharge = (wallbedUpcharge != null) ? parseFloat(wallbedUpcharge) : 0;
			let currentUpcharge = (this.price_totals.finish_wallbed_upcharge != null) ? parseFloat(this.price_totals.finish_wallbed_upcharge) : 0;
			let currentPrice = parseFloat(this.price_totals.base) + currentUpcharge;
			let optionBase = 0;
			if (this.selected_size) {
				for (let i = 0; i < this.selected_size.prices.length; ++i) {
					let po = this.selected_size.prices[i];
					for (let j = 0; j < po.woods.length; ++j) {
						if (po.woods[j].id == finish.wood.id) {
							optionBase = parseFloat(po.price);
							break;
						}
					}
				}
			}

			let optionPrice = optionBase + wallbedUpcharge;
			let priceChange = optionPrice - currentPrice;
			return priceChange;
		}
	},
	computed: {
		...mapState({
			selected_size: state => state.selected_size,
			bed_sizes: state => state.bed_sizes,
			popular_finishes: state => state.popular_finishes,
			selected_popular_finish: state => state.selected_popular_finish,
			woods: state => state.woods,
			wood_finishes: state => state.wood_finishes,
			price_totals: state => state.totals,
			useDiscounts: state => state.useDiscounts
		})
	},
	watch: {
		selectedSizeId(val) {
			for (let i in this.bed_sizes) {
				let row = this.bed_sizes[i];
				if (row.id == val) {
					this.$store.commit('setSelectedSize', row);
					break;
				}
			}
		},
		selected_size(val) {
			if (val && val.id && val.id != this.selectedSizeId) {
				this.selectedSizeId = val.id;
			}
		}
	}
}
</script>